/**
 * Animation easing utilities shared across animated canvas transitions.
 */

/**
 * Ease-in-out cubic: starts slow, accelerates through the middle, then decelerates to a stop.
 * @param t - normalised time value in [0, 1]
 */
export function easeInOutCubic(t: number): number {
    return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
}
